import * as React from 'react';
export const cancelCircleFilledSvg = React.forwardRef(
  function cancelCircleFilledSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM5.53 4.47a.75.75 0 0 0-1.06 1.06L6.94 8l-2.47 2.47a.75.75 0 1 0 1.06 1.06L8 9.06l2.47 2.47a.75.75 0 1 0 1.06-1.06L9.06 8l2.47-2.47a.75.75 0 0 0-1.06-1.06L8 6.94 5.53 4.47Z',
      }),
    );
  },
);
cancelCircleFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cancelCircleFilled = {
  category: 'icon',
  colorable: true,
  name: 'cancelCircleFilled',
  svg: cancelCircleFilledSvg,
};
